import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SessionTimer = () => {
  const [timeLeft, setTimeLeft] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const expiry = localStorage.getItem("session_expiry");

    if (!expiry) return; // nothing to show

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const diff = expiry - now;

      if (diff <= 0) {
        clearInterval(interval);
        localStorage.clear();
        navigate("/");
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  if (!timeLeft) return null;

  // format mm:ss
  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    <div
      style={{
        position: "fixed",
        top: "10px",
        right: "10px",
        background: "#343a40",
        color: "#fff",
        padding: "8px 14px",
        borderRadius: "8px",
        fontSize: "14px",
        zIndex: 9999,
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      }}
    >
      Session expires in {minutes}:{seconds.toString().padStart(2, "0")}
    </div>
  );
};

export default SessionTimer;
